import React from "react";
import Logo from "media/logo.png";
import { withRouter } from "react-router";
class Loader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadPage: false
    };
    this.props.history.listen(async (location, action) => {
      await this.setState({
        location: this.props.location
      });
      if (location.pathname !== this.state.location.pathname) {
        // await this.setState({
        // });
        this.setState({
          loadPage: false,
          loading: true
        });
        setTimeout(() => {
          this.setState({ loading: false });
          // this.setState({loadPage : true});
        }, 2000);
        setTimeout(() => {
          this.setState({ loadPage: true });
        }, 100);
      }
    });
  }
  componentDidMount() {
    this.setState({
      location: this.props.location
    });
    setTimeout(() => {
      this.setState({ loadPage: true });
    }, 100);
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000);
  }
  render = () => [
    <div
      style={{
        // filter: `blur(${this.state.loading ? 0 : 5}px)`,
        opacity: this.state.loading ? 1 : 0,
        zIndex: this.state.loading ? 999999999 : -1
      }}
      className="loader"
    >
      <img src={Logo} />
    </div>,

    this.state.loadPage ? this.props.children : null
  ];
}
export default withRouter(Loader);
